import 'slick-carousel';
import 'lightbox2';

export default {
  init() {
     
     jQuery('.slick-carousel').each(function(){

        var duration = $(this).attr('data-autoplay-speed');

        if(duration == undefined){
            duration = 5000;
        }

        $(this).slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: duration,
            arrows: true,
          });

     });


      $(document).ready(function(){
        // evidenzio anche il parent del sottoelemento corrente nella navbar
        var context = $('.navbar-nav ul');
        $('.dropdown-item.active').parents('li', context).addClass('current-menu-item');
        
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        
        console.log('touch ' + touchsupport);
        if(!touchsupport){
          //$(".dropdown-toggle").hover(function(){
          $(".dropdown-toggle").mouseover(function(){
              //$(this).next('.dropdown-menu').addClass('show');
              $(this).trigger('click');
          });
        }

          $(".dropdown-toggle").click(function(){
            //e.stopPropagation();
            console.log('click');
          });
      });

     // gestisco la visualizzazione della barra di ricerca
     $('.search-toggle').click(function(){
        
        $('.search-form-container').toggleClass('d-none');
     });
 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js